import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/font.css';

// Tailwind importiert
import './assets/tailwind.css'

createApp(App).use(router).mount('#app')
